import Vue from 'vue'
import Toasted from 'vue-toasted'
import {mapGetters, mapActions} from 'vuex'
import store from '@/store/store';

// const eventHub = new Vue();
import {eventHub} from './main'

export default {
    install (Vue, options) {
        Vue.mixin({
            data: function () {
                return {
                    eventHub: eventHub
                }
            },
            computed: {
                ...mapGetters([
                    'getUserAccessType',
                    'getNotifications',
                ]),
                // Feature Flags (uses .env to show or hide features)
                featureFlags: function () {
                    return {
                        showCutoff: process.env.FEATURE_CUTOFF,
                        showRefunds: process.env.FEATURE_REFUNDS
                    }
                },
            },
            methods: {
                ...mapActions([
                    'fetchNotifications',
                    'addFloatingNotification',
                    'removeAllFloatingNotifications',
                    'displayRichPrompt',
                    'hideRichPrompt',
                    'updateClonedItem',
                ]),
                downloadNotifications: function () {
                    let vm = this
                    this.fetchNotifications().then(output => {

                        if(!output){
                            return false
                        }

                        // If is the first notification pull and there are unread notifications
                        // Have notifications AND stored notifications == 0
                        let storedNotifications = JSON.parse(JSON.stringify(output.previousStoredNotifications))
                        if(output && output.allNotifications.length > 0 && storedNotifications.length == 0){
                            let unreadNotifications = output.allNotifications.filter(notification => {
                                return !notification.markedAsRead
                            })

                            if(unreadNotifications.length > 0){
                                this.spawnNotification({
                                    title: 'You have '+unreadNotifications.length+' unread notifications'
                                }, 'info')

                            }
                        } else if(output && output.newNotifications.length > 0 && storedNotifications.length > 0){
                            for (let newNotification of output.newNotifications) {
                                let options = {}
                                if(newNotification.type == 3){
                                    options.link = '/reservations'
                                }
                                this.spawnNotification(newNotification, 'info', options)
                            }
                        }
                    });
                },
                spawnNotification: function (notification, type, options) {
                    // *******************************************
                    // notification.title
                    // notification.message
                    // notification.date
                    // *******************************************
                    // type: tip | info | success | warning | alert
                    // *******************************************
                    // options.link
                    // *******************************************
                    let useSystemNotification = false
                    
                    if(useSystemNotification){
                        if('Notification' in window && Notification.permission == 'granted'){
                            this.spawnNotificationBrowser(notification, type, options)
                        } else {
                            this.spawnNotificationCustom(notification, type, options)
                        }
                    } else {
                        this.spawnNotificationCustom(notification, type, options)
                    }
                },
                spawnNotificationBrowser: function (notification, type, options) {
                    options = (typeof options == 'object')? options : {}
                    let icon = '/static/favicon/ms-icon-310x310.png'
                    var spawnedNotification = new Notification(
                        notification.title,
                        {
                            icon: icon,
                            body: notification.message
                        }
                    );
                },
                spawnNotificationCustom: function (notification, type, options) {
                    // Testing new floating notifications
                    this.addFloatingNotification(notification)
                },
                clearAllCustomNotifications: function () {
                    this.removeAllFloatingNotifications()
                    if(this.$awn.container){
                        for (let notification of this.$awn.container.children) {
                            notification.click()
                        }
                    }
                },
                accessPermissionFilter: function(permissionCodeArray) {
                    // receives and array of access codes (example: ["admin","basic"])
                    // and returns bool true if current user corresponds to access code
                    // if undefined defaults to basic user
                    // check store user.js
                    // return true // debug

                    // also allows for group (see the "supervisor" example)
                    return permissionCodeArray.filter(reqAccessCode => {
                        return reqAccessCode == this.getUserAccessType.code || reqAccessCode == this.getUserAccessType.group
                    }).length > 0
                },
                formatPrice: function(price) {
                    let rounded = Math.round(price * 100) / 100;
                    return parseFloat(rounded).toFixed(2);
                },
                roundPriceValue: function(price) {
                    return Math.round(price * 100) / 100;
                },
                formatTicketNumber: function(ticketNr) {
                    let targetLength = 5; //ex.: 000123
                    ticketNr = ticketNr + '';

                    return '#'+ (ticketNr.length >= targetLength ? ticketNr : new Array(targetLength - ticketNr.length + 1).join('0') + ticketNr);
                },
                formatDate: function(date) {
                    return moment(date).format('YYYY-MM-DD');
                },
                formatDateDots: function(date) {
                    return moment(date).format('DD.MM.YYYY');
                },
                formatTime: function(date) {
                    return moment(date).format('HH:mm');
                },
                calculateDuration: function (staringTime, endingTime) {
                    // time format: "2018-06-11 15:00:00"
                    var timeStart = moment(staringTime);
                    var timeEnd = moment(endingTime);

                    var duration = timeEnd.diff(timeStart)

                    return moment.utc(duration).format('HH')+'h'+moment.utc(duration).format('mm') + 'm'
                },
                hourToDuration: function(hourString) {
                    // format: 01:00:00
                    let durationArr = hourString.split(":")

                    let hours = durationArr[0]
                    let minutes = durationArr[1]

                    return hours+'h'+minutes+'m'
                },
                nowDate: function() {
                    return moment().format('YYYY-MM-DD');
                },
                nowTime: function() {
                    return moment().format('HH:mm');
                },
                // Creates an URI encoded query string from a JSON array
                parseQueryString: function(params) {
                    let esc = encodeURIComponent;
                    return Object.keys(params).map(k => esc(k) + '=' + esc(params[k])).join('&');
                },
                // Adds leading zeros to numbers smaller than 10 (01, 02 ...) on a list
                leadingZeros: function(list) {
                    let newList = [];

                    list.forEach(number => {
                        newList.push(('0' + number).slice(-2));
                    });

                    return newList;
                },
                getMonthDateRange: function(date) {
                    // Month in moment is 0 based, so 9 is actually october, subtract 1 to compensate
                    let start = moment(date).startOf('month');
                    let end = moment(date).endOf('month');

                    return { start: this.formatDate(start), end: this.formatDate(end) };
                },
                getWeekDateRange: function(date) {
                    let start = moment(date).startOf('isoWeek');
                    let end = moment(date).endOf('isoWeek');

                    return { start: this.formatDate(start), end: this.formatDate(end) };
                },
                showTicketPrice: function(eventGenderPrice) {
                    if (eventGenderPrice && eventGenderPrice.grossprice !== undefined) {
                        return eventGenderPrice.grossprice;
                    } else {
                        return null;
                    }
                },
                showMandatoryExtras: function(reservation) {
                    if(reservation.event.product.extras.length > 0){
                        var mandatoryExtrasArr = reservation.event.product.extras.filter(extra => {
                            return extra.isMandatory
                        })

                        if(mandatoryExtrasArr.length > 0){
                            var extrasNameArr = []
                            mandatoryExtrasArr.map(extra => {
                                extrasNameArr.push(extra.item.name + ' - ' + extra.item.selectedPrice.name)
                            })

                            this.$dialog.alert('The following '+ ((mandatoryExtrasArr.length > 1)? 'extras are':'extra is') +' mandatory: <br>' + extrasNameArr.join('<br>') , {okText: 'OK'})
                            .then(function () {

                            })
                            .catch(function () {
                            });
                        }

                    } else {
                        return false
                    }
                },

                openByteArrayNewTab: function (byteArray, filename) {
                    if (!filename) {
                        filename = 'file';
                    }
                
                    // Open the window immediately to avoid pop-up blockers
                    let pdfWindow = window.open('about:blank', '_blank');
                
                    if (!pdfWindow) {
                        alert('Pop-up bloqueado! Por favor, permita pop-ups para este site.');
                        return;
                    }
                
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        // Specific code for IE
                        var byteCharacters = atob(byteArray);
                        var byteNumbers = new Array(byteCharacters.length);
                        for (var i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        var uint8Array = new Uint8Array(byteNumbers);
                        var blob = new Blob([uint8Array], { type: 'application/pdf' });
                        window.navigator.msSaveOrOpenBlob(blob, filename + '.pdf');
                        // Windows close, IE deals with files differently
                        pdfWindow.close(); 
                    } else {
                        if (byteArray instanceof ArrayBuffer) {
                            const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
                            const pdfUrl = URL.createObjectURL(pdfBlob);
                            // Defines the location of the open window for the PDF URL
                            pdfWindow.location.href = pdfUrl;
                        } else {
                            let encodedByteArray = encodeURIComponent(byteArray);
                            let htmlContent = "<div style='display:flex;justify-content:flex-end; font-weight: 300;align-items: center;padding: 20px; text-align: center;font-family: sans-serif; letter-spacing: 0.5; margin-bottom: 5px;background-color: rgb(54 58 61);'>" +
                                "<span style='color:#fff;font-size: 1.0rem;margin-right: 0.3rem;'>If your file is not showing, click </span>" +
                                "<a href='data:application/pdf;base64," + encodedByteArray + "' download='" + filename + "' style='color:rgb(54 58 61); font-size: 1.0rem; background-color: #fff;text-decoration:none;border-radius: 4px; border:#dfdddd 1px solid;padding: 7px 10px;'>Download</a>" +
                                "</div>" +
                                "<iframe width='100%' height='100%' frameBorder='0' src='data:application/pdf;base64," + encodedByteArray + "'></iframe>";
                
                            // Write the content in the new window
                            pdfWindow.document.open();
                            pdfWindow.document.write(htmlContent);
                            pdfWindow.document.close();
                        }
                    }
                },
                // Inventory -> Product
                productAcivateUpdateFlag: function (flagName) {
                    if(!this.form.updateFlags){
                        this.$set(this.form, 'updateFlags', {})
                    }
                    this.form.updateFlags[flagName] = true
                    this.updateClonedItem(this.form);
                },
                // Modal -> EventEdit
                eventActivateUpdateFlag: function (flagName) {
                    store.dispatch('addSelectedEventUpdateFlag', flagName)
                },
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/mixins.js